import {SchoolBlocksAppApi} from "./Api";

export default new SchoolBlocksAppApi();
